/* eslint-disable */
export default {
  to: 'To',
  enterNameOrNumber: 'Enter name or number',
} as const;

// @key: @#@"to"@#@ @source: @#@"To"@#@
// @key: @#@"enterNameOrNumber"@#@ @source: @#@"Enter name or number"@#@
